import styled from "styled-components";

export const PassFail = styled.div`
  .PassBorderDiv {
    border: 1px solid ${({ theme }) => theme.colors.greenPrimary || "#11A70B"};
  }
  .FailBorderDiv {
    border: 1px solid ${({ theme }) => theme.colors.redPrimary || "#DD0000"} !important;
  }
  .TimedOutBorderDiv {
    border: 1px solid ${({ theme }) => theme.colors.grayL1 || "#323232"} !important;
  }

  #button-container {
    position: relative;
    width: 100px;
    height: 24px;
    border-radius: 4px;
    overflow: hidden;
    text-align: center;
  }

  #nameUserStyle {
    position: absolute;
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
    left: -100%;
    transition: 0.5s;
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #statusStyle {
    position: relative;
    left: 0;
    transition: 0.5s;
    cursor: pointer;
    display: block;
    width: 100%;
  }

  #button-container:hover #nameUserStyle {
  }

  #button-container:hover #statusStyle {
  }

  i {
    float: initial;
    text-align: left;
    padding-left: 6px;
    display: inline-block;
    font-weight: bold;
    font-size: ${({ theme }) => theme.fontSizes.font7};
    line-height: ${({ theme }) => theme.lineHeights.line5};
    vertical-align: middle;
  }
`;

export const StyledSpan = styled.span`
  height: ${(props) => `calc(100vh - ${props.height}px)`};
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  font-size: ${({ theme }) => theme.fontSizes.font4} !important;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  clear: both;
  text-align: center;
  @media screen and (max-width: 800px) {
    font-size: ${({ theme }) => theme.fontSizes.font5} !important;
  }
`;

export const LoaderOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8); /* semi-transparent white */
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;
